<template>
    <div>
        Instruction:
        <TipTap
            v-model="editable_content.instruction"
            :menu_items="['bold', 'italic', 'underline', 'image', 'edit_html']"
            :editable_content="editable_content"
        />

        Question:
        <TipTap
            v-model="editable_content.question"
            :menu_items="['bold', 'italic', 'underline', 'bullet_list', 'ordered_list', 'hot_text']"
            :editable_content="editable_content"
            @input="handleTipTapUpdate"
        />

        <b-form-invalid-feedback class="mb-2" :state="validating && !editable_content.question ? false : null">
            A question is required.
        </b-form-invalid-feedback>

        <b-form-invalid-feedback class="mb-2" :state="validating && !editable_content.instruction ? false : null">
            An Instruction is required.
        </b-form-invalid-feedback>

        <b-form-invalid-feedback class="mb-2" :state="validating && hasTwoTargets() ? false : null">
            At least 2 Hot Text Targets are required
        </b-form-invalid-feedback>

        <b-form-invalid-feedback class="mb-2" :state="validating && hasCorrectTarget() ? false : null">
            At least 1 Correct target is required
        </b-form-invalid-feedback>

    </div>
</template>

<style lang="scss" scoped>
.prompt {
    min-height: 6rem;
}
</style>
<style>
    .ProseMirror table {
    width: 100%;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        options: [],

        editor: null,
        editable_content: {},
        selected_text: null
    }),
    props: [
        'question'
    ],
    components: {
        TipTap: () => import('@/components/tiptap/TipTap'),
    },
    computed: {
        ...mapState({
            validating: state => state.utilities.validating
        }),
        blankWithoutAnswer () {
            let blankWithoutAnswer = false

            if (this.editable_content.blanks) {
                _.forEach(this.editable_content.blanks, blank => {
                    if (!blank.answer) {
                        blankWithoutAnswer = true
                    }
                })
            }

            return blankWithoutAnswer
        }
    },
    watch: {
        question: {
            handler (question) {
                if (
                    question &&
                    question.content
                ) {
                    this.editable_content = question.content
                }
                
            },
            deep: true,
            immediate: true
        },

        editable_content: {
            handler (editable_content) {
                if (editable_content) {
                    this.$set(this.question, 'content', editable_content)
                }
            },
            deep: true
        },

    },
    methods: {
        handleTipTapUpdate(question) {
            if (question) {
                this.$set(this.editable_content, 'question', question)

                let parser = new DOMParser()
                let html = parser.parseFromString(question, 'text/html')
                let hotTextCollection = html.getElementsByTagName('hot_text')

                let hotTextArrayMap = _.map(hotTextCollection, hot_text => {
                    let hot_text_id = hot_text.getAttribute('hot_text_id')

                    if (!this.editable_content.options) {
                        this.$set(this.editable_content, 'options', [])
                    }

                    if (!_.find(this.editable_content.options, {hot_text_id: hot_text_id})) {
                        this.editable_content.options.push({
                            hot_text_id: hot_text_id,
                        })
                    }

                    return {
                        hot_text_id: hot_text_id
                    }
                })

                if (
                    this.editable_content.options &&
                    this.editable_content.options.length
                ) {
                        _.forEach(this.editable_content.options, (option, index) => {
                            let hot_text_id = null

                            if (
                                option &&
                                option.hot_text_id
                            ) {
                                hot_text_id = option.hot_text_id
                            }

                            if (!_.find(hotTextArrayMap, {hot_text_id: hot_text_id})) {
                                this.editable_content.options.splice(index, 1)
                            }
                        })
                    } else {
                        this.$set(this.editable_content, 'options', [])
                    }
                } else {
                    this.$set(this.editable_content, 'options', [])
                }
        },
        hasTwoTargets(){
            //confirm that at least 2 options and at least one is correct
            const number_of_targets = (this.editable_content.question.match(/<hot_text/g) || []).length;
            if(number_of_targets < 2){
                return true;
            }
            else{
                return false;
            }
        },
        hasCorrectTarget(){
            //confirm that at least 1 option is correct
            const number_of_correct_targets = (this.editable_content.question.match(/hot_text_correct/g) || []).length;
            if(number_of_correct_targets < 1){
                return true;
            }
            else{
                return false;
            }
        }
    },
}
</script>
